import React from 'react';
import { Button } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { Link } from 'react-router-dom';
import signin from "../../../assets/img/signin.svg";
import Footer from '../../Layout/Footer';
import Header from '../../Layout/Header';


const SubmitSignUp = () => {
    return (
        <React.Fragment>
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>
                                    Sign Up </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Sign Up</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="signinpage">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <img src={signin} alt="" className="img-fluid" />
                        </div>
                        <div className="col-lg-6">
                            <div className="login-wrap">
                                <div className="login-html">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="signintitle">
                                                <h1>Sign Up</h1>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="login-form">
                                        <Form>
                                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                                <Form.Label>User Name <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                <Form.Control type="text" placeholder="Enter the Username" />
                                            </Form.Group>

                                            <Form.Group className="mb-3" controlId="formBasicPassword">
                                                <Form.Label>Create Password <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                <Form.Control type="text" placeholder="Password" />
                                            </Form.Group>

                                            <Form.Group className="mb-3" controlId="formBasicPassword">
                                                <Form.Label>Confirm Password <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                <Form.Control type="text" placeholder="Password" />
                                            </Form.Group>

                                            <div className="group">
                                                <Button type="submit" className="btn btn-primary next-btn mt-3 mb-3">Proceed</Button>
                                                <Button type="submit" className="btn btn-primary next-btn mt-3 mb-3">Back</Button>
                                            </div>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment>
    )
}

export default SubmitSignUp;